import React, { Component } from 'react';
import moment from 'moment';
import { Result, Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import LoadingPage from '../../components/LoadingPage';
import { db } from '../../config/Fire';
import * as Constants from './../../constants/nodes_database';
import ErrorPage from '../../components/ErrorPage';
import UsersTableAdmin from '../../components/tables/UsersTableAdmin';
import ReservationsByUserTableAdmin from '../../components/tables/ReservationsByUserTableAdmin';
import { Grid, Row, Col } from 'react-flexbox-grid';

function compareNames( a, b ) {
    if ( a.lastName > b.lastName ) {
        return 1;
    }
    if ( a.lastName < b.lastName ) {
        return -1;
    }
    if ( a.firstName > b.firstName ) {
        return 1;
    }
    if ( a.firstName < b.firstName ) {
        return -1;
    }
    return 0;
};

function reservationsByDateHour( a, b ) {
    var dateA = moment(a.date, 'DD/MM/YYYY');
    var dateB = moment(b.date, 'DD/MM/YYYY');
    var hourA = moment(a.hour, 'HH:mm');
    var hourB = moment(b.hour, 'HH:mm');

    if ( dateA.isBefore(dateB) ) {
        return 1;
    }
    if ( dateA.isAfter(dateB) ) {
        return -1;
    }
    if ( a.hour === "00:00" && b.hour === "00:00" ) {
        return 0;
    }
    if ( a.hour === "00:00" ) {
        return 1;
    }
    if ( b.hour === "00:00" ) {
        return -1;
    }
    if ( hourA.isBefore(hourB) ) {
        return -1;
    }
    if ( hourA.isAfter(hourB) ) {
        return 1;
    }
    return 0;
};

class UsersAdmin extends Component {
    state = {
        users: null,
        error: false,
        idUserSelected: null,
        userSelected: null,
        reservationsByUserId: null,
        restaurants: null,
    }

    getUsers = () => {
        db.ref(`${Constants.USERS}`).once("value")
        .then((usersSnap) => {
            if(usersSnap.exists()) {
                var users = [];
                usersSnap.forEach(userSnap => {
                    users.push(userSnap.val());
                });
                users.sort(compareNames);
                this.setState({ users: users });
            } else {
                this.setState({ users: null, error: true });
            }
        })
        .catch(() => {
            this.setState({ users: null, error: true });
        })
    }

    onUserReservationsById = user => {
        this.setState({ idUserSelected: user.uid, userSelected: user });
    }

    onBackPressedReservations = () => {
        this.setState({ idUserSelected: null, userSelected: null, reservationsByUserId: null, restaurants: null });
    }

    getReservationsByUserId = uid => {
        if(uid && !this.state.reservationsByUserId) {
            const reservationsByUserId = [];
            const restaurantsWithReservationsByUserId =  {};
            db.ref(`${Constants.RESERVATIONS}`).orderByChild("userId").equalTo(uid).once("value")
            .then(reservationsSnap => {
                if(reservationsSnap.exists()) {
                    reservationsSnap.forEach(reservationSnap => {
                        var reservation = reservationSnap.val();
                        if(!restaurantsWithReservationsByUserId[reservation.restoId]) {
                            restaurantsWithReservationsByUserId[reservation.restoId] = reservation.restoName;
                        }
                        reservationsByUserId.push(reservation);
                    });
                    reservationsByUserId.sort(reservationsByDateHour);
                }
                var restaurants = [];
                for(var key in restaurantsWithReservationsByUserId) {
                    restaurants.push({ text: restaurantsWithReservationsByUserId[key], value: key });
                }
                this.setState({ reservationsByUserId: reservationsByUserId, restaurants: restaurants });
            })
            .catch(() => {
                this.setState({ users: null, error: true, idUserSelected: null, userSelected: null , reservationsByUserId: null, restaurants: null });
            })
        }
    }

    render() {
        const { error, users, idUserSelected, userSelected, reservationsByUserId, restaurants } = this.state;
        return (
            <div>
                {
                    error ?
                        <ErrorPage />
                        :
                        users ?
                            idUserSelected ?
                                <div>
                                    {
                                        this.getReservationsByUserId(idUserSelected)
                                    }
                                    {
                                        reservationsByUserId ?
                                            reservationsByUserId.length !== 0 ?
                                                <div>
                                                    <Grid>
                                                        <Row center="sm">
                                                            <Col xs={12} sm={12} md={4}>
                                                                <Button onClick={this.onBackPressedReservations}>
                                                                    <LeftOutlined />Volver a los usuarios
                                                                </Button>
                                                            </Col>
                                                            <Col xs={12} sm={6} md={4}>
                                                                <h3>Usuario: {(userSelected && userSelected.firstName !== undefined && userSelected.lastName !== undefined) ? `${userSelected.firstName + " " + userSelected.lastName}` : "-"}</h3>
                                                            </Col>
                                                            <Col xs={12} sm={6} md={4}>
                                                                <h3>Email: {(userSelected && userSelected.email !== undefined) ? `${userSelected.email}` : "-"}</h3>
                                                            </Col>
                                                        </Row>
                                                        <Row center="xs">
                                                            <Col xs={12}>
                                                                <ReservationsByUserTableAdmin data={reservationsByUserId} restaurants={restaurants}/>
                                                            </Col>
                                                        </Row>
                                                    </Grid>
                                                </div>
                                                :
                                                <div>
                                                    <Button onClick={this.onBackPressedReservations}>
                                                        <LeftOutlined />Volver a los usuarios
                                                    </Button>
                                                    <Result status="warning" title="No hay reservas para el usuario indicado." />
                                                </div>
                                            :
                                            <LoadingPage />
                                    }
                                </div>
                                :
                                <Grid>
                                    <Row start="xs">
                                        <Col xs={12} sm={6}>
                                            <h3>Cantidad de usuarios: {users.length}</h3>
                                        </Col>
                                        <Col xs={12} sm={6}>
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={12} style={{paddingTop: '20px'}}>
                                            <UsersTableAdmin data={users} onUserReservationsById={this.onUserReservationsById}/>
                                        </Col>
                                    </Row>
                                </Grid>
                            :
                            this.getUsers()
                }
            </div>
        );
    }
}

UsersAdmin.propTypes = {

};

export default UsersAdmin;